var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pamphlet_theme",attrs:{"id":"app"}},[_c(_vm.activeTemplate,{tag:"component",attrs:{"blocks":_vm.blocks,"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }